import React, { useEffect, useRef, useState } from "react";
import patient from "../../assets/img/patient.jpg";
import { useParams } from "react-router";
import {
  GET_BACKGROUND_REPORT,
  GET_CLINICAL_INTERVIEW,
  GET_COLLATERAL_REPORT,
  GET_DIAGNOSE,
  GET_FORMULATION,
  GET_HISTORY_REPORT,
  GET_MENNTAL_STATUS_EXAMINATION,
  GET_RECOMMENDATION,
  GET_STANRADISED_ASSESSMENT,
  PATIENT_PAITENT_REPORT_API_URL,
  PATIENT_REPORT_API_URL,
} from "../../action/apiPath";
import { CallWithAuth } from "../../action/apiActions";
import MetadataSection from "./MetadataSection";
import moment from "moment";
import { marked } from "marked";
import TurndownService from "turndown";
// import ReactQuill from "react-quill";
import { QUILL_FORMATS, QUILL_MODULES } from "../../util/constant";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import { showToast, ToastContainer } from "../../util/toastHelper";
import {
  convertImageToBase64,
  reportDateDwonaloadDateFormat,
  safeMarkedWrapper,
} from "../../util/custom";
import { LoaderIndex } from "../../components/Loader/LoaderIndex";
import { Editor } from "@tinymce/tinymce-react";
import { tinymceApiKey, tinymceConfig } from "../../util/tinymceConfig";
import logo from "../../assets/img/logo.svg";

import htmlToPdfMake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import Swal from "sweetalert2";

import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

// Dynamically load fonts
pdfMake.vfs = {
  ...pdfMake.vfs,
  "Roboto-Regular.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-Regular.ttf").default,
  "Roboto-Medium.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-Medium.ttf").default,
  "Roboto-Italic.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-Italic.ttf").default,
  "Roboto-MediumItalic.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-MediumItalic.ttf")
      .default,
};

// Define custom fonts
pdfMake.fonts = {
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};
const PatientReportInformationPage = () => {
  const { id } = useParams();
  const turndownService = new TurndownService();

  const [reportData, setReportData] = useState(null);
  const [reportPatientData, setReportPatientData] = useState(null);
  const [apiEndPoints, setApiendPoints] = useState([
    // {
    //   endPoint:GET_SPEAKER_IDENTIFY_REPORT,
    //   type:'Speaker Identify',
    // },
    {
      endPoint: GET_BACKGROUND_REPORT,
      type: "Background Information",
      key: "background_info",
    },
    {
      endPoint: GET_HISTORY_REPORT,
      type: "history  Information",
      key: "history",
    },
    {
      endPoint: GET_COLLATERAL_REPORT,
      type: "Collateral Report",
      key: "collateral",
    },
    {
      endPoint: GET_MENNTAL_STATUS_EXAMINATION,
      type: "Mental Status Examination",
      key: "mse",
    },
    {
      endPoint: GET_STANRADISED_ASSESSMENT,
      type: "Standardised Assessment",
      key: "standardised_assessment",
    },
    {
      endPoint: GET_CLINICAL_INTERVIEW,
      type: "Clinical Interview",
      key: "clinical_interviews",
    },
    {
      endPoint: GET_FORMULATION,
      type: "formulation",
      key: "formulation",
    },
    {
      endPoint: GET_DIAGNOSE,
      type: "DSM-5-TR/ICD-11 Diagnoses",
      key: "diagnose",
    },
    {
      endPoint: GET_RECOMMENDATION,
      type: "Recommendations",
      key: "recommendation",
    },
  ]);
  const editorRef = useRef(null);
  // const [reportgenerateData, setReportgenerateData] = useState({
  //   background_info: "",
  //   clinical_interviews: "",
  //   mse: "",
  //   standardised_assessment: "",
  //   collateral: "",
  //   formulation: "",
  //   diagnose: "",
  //   recommendation: "",
  // });
  const [reportgenerateData, setReportgenerateData] = useState({
    background_info: "",
    background_info_generated: false,

    history: "",
    history_generated: false,

    collateral: "",
    collateral_generated: false,

    mse: "",
    mse_generated: false,

    standardised_assessment: "",
    standardised_assessment_generated: false,

    clinical_interviews: "",
    clinical_interviews_generated: false,

    formulation: "",
    formulation_generated: false,

    diagnose: "",
    diagnose_generated: false,

    recommendation: "",
    recommendation_generated: false,
  });
  const [reportDisplayStatus, setReportDisplayStatus] = useState({
    background_info: false,
    history: false,
    collateral: false,
    mse: false,
    standardised_assessment: false,
    clinical_interviews: false,
    formulation: false,
    diagnose: false,
    recommendation: false,
  });
  const [getResults, setResults] = useState([]);
  const [cureentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isReportGenerate, setIsReportGenerate] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);

  const [editorContent, setEditorContent] = useState("");
  const [editorHistoryContent, setEditorHistoryContent] = useState("");
  const [editorCollateralContent, setEditorCollateralContent] = useState("");
  const [editorMseContent, setEditorMseContent] = useState("");

  const [editorStandardisedContent, setEditorStandardisedContent] =
    useState("");
  const [editorClinicalInterviewsContent, setEditorClinicalInterviewsContent] =
    useState("");

  const [editorFormulationContent, setEditorFormulationContent] = useState("");
  const [editorDiagnoseContent, setEditorDiagnoseContent] = useState("");
  const [editorRecommendationContent, setEditorRecommendationContent] =
    useState("");

  const [isReportDownload, setIsReportDownload] = useState("");
  const [isApprovedLoading, setIsApprovedLoading] = useState("");

  useEffect(() => {
    getPatientReportApiCall();
    getPatientReportRecordApiCall();
    // getReportAlldetail();
  }, []);
  useEffect(() => {
    if (!reportGenerated) {
      getReportAlldetail();
    }
  }, [cureentIndex]);
  // Effect to set initial content from DB
  useEffect(() => {
    if (reportgenerateData?.background_info) {
      setEditorContent(reportgenerateData.background_info);
    }
    if (reportgenerateData?.history) {
      setEditorHistoryContent(reportgenerateData.history);
    }
    if (reportgenerateData?.collateral) {
      setEditorCollateralContent(reportgenerateData.collateral);
    }
    if (reportgenerateData?.mse) {
      setEditorMseContent(reportgenerateData.mse);
    }

    if (reportgenerateData?.standardised_assessment) {
      setEditorStandardisedContent(reportgenerateData.standardised_assessment);
    }

    if (reportgenerateData?.clinical_interviews) {
      setEditorClinicalInterviewsContent(
        reportgenerateData.clinical_interviews
      );
    }

    if (reportgenerateData?.formulation) {
      setEditorFormulationContent(reportgenerateData.formulation);
    }

    if (reportgenerateData?.diagnose) {
      setEditorDiagnoseContent(reportgenerateData.diagnose);
    }

    if (reportgenerateData?.recommendation) {
      setEditorRecommendationContent(reportgenerateData.recommendation);
    }
  }, [reportgenerateData]);
  const getPatientReportRecordApiCall = async () => {
    try {
      const response = await CallWithAuth(
        "GET",
        `${PATIENT_PAITENT_REPORT_API_URL}${id}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        setReportPatientData(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
  };

  const getPatientReportApiCall = async () => {
    try {
      const response = await CallWithAuth(
        "GET",
        `${PATIENT_REPORT_API_URL}${id}/?extra=false`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        setReportData(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
  };

  const getReportAlldetail = async () => {
    try {
      if (apiEndPoints[cureentIndex].endPoint != undefined) {
        const response = await CallWithAuth(
          "GET",
          `${apiEndPoints[cureentIndex].endPoint}${id}`
        );
        // console.log("currentKey",apiEndPoints[cureentIndex].key);

        // setCurrentIndex(cureentIndex+1);
        // if ( response?.res?.data?.statusCode === "ok") {
        // console.log(response?.res?.data?);

        if (response?.res?.data?.statusCode === 200) {
          if (
            apiEndPoints[cureentIndex].endPoint === GET_BACKGROUND_REPORT &&
            response?.res?.data?.data?.is_approved
          ) {
            console.log("apiEndpints===>", apiEndPoints);
            console.log(response?.res?.data?.data?.collateral);

            setReportgenerateData((pre) => ({
              ...pre,
              background_info: marked(
                response?.res?.data?.data?.background_info
              ),
              background_info_generated: true,

              history: marked(response?.res?.data?.data?.history),
              history_generated: true,

              collateral: marked(response?.res?.data?.data?.collateral),
              collateral_generated: true,

              mse: response?.res?.data?.data?.mse,
              mse_generated: true,

              standardised_assessment: marked(
                response?.res?.data?.data?.standardised_assessment
              ),
              standardised_assessment_generated: true,

              clinical_interviews: marked(
                response?.res?.data?.data?.clinical_interviews
              ),
              clinical_interviews_generated: true,

              formulation: marked(response?.res?.data?.data?.formulation),
              formulation_generated: true,

              diagnose: marked(response?.res?.data?.data?.diagnose),
              diagnose_generated: true,

              recommendation: marked(response?.res?.data?.data?.diagnose),
              recommendation_generated: true,
            }));
            setIsReportGenerate(true);

            // console.log("566");
            setReportGenerated(true);
          } else {
            setReportgenerateData((prevResults) => ({
              ...prevResults,
              [apiEndPoints[cureentIndex].key]: marked(
                response?.res?.data?.data?.[apiEndPoints[cureentIndex].key]
              ),
              [`${apiEndPoints[cureentIndex].key}_generated`]: true,
            }));
          }
          // setResults((prevResults) => [
          //   ...prevResults,
          //   { type: apiEndPoints[cureentIndex].type, data: response?.res?.data?.data ,hasResult:true },
          // ]);

          if (apiEndPoints[cureentIndex].endPoint === GET_RECOMMENDATION) {
            setIsReportGenerate(true);
          }
        } else {
          if (apiEndPoints[cureentIndex].endPoint === GET_RECOMMENDATION) {
            setIsReportGenerate(true);
          }
          // console.log('132',response?.res?.data?.message);
          // setResults((prevResults) => [
          //   ...prevResults,
          //   { type: apiEndPoints[cureentIndex].type, message: response?.res?.data?.message ,hasResult:false },
          // ])
          setReportgenerateData((prevResults) => ({
            ...prevResults,
            [apiEndPoints[cureentIndex].key]: response?.res?.data?.message,
            [`${apiEndPoints[cureentIndex].key}_generated`]: true,
          }));
        }
        setCurrentIndex(cureentIndex + 1);
      } else {
        if (apiEndPoints[cureentIndex].endPoint === GET_RECOMMENDATION) {
          setIsReportGenerate(true);
        }
        // console.log("215", apiEndPoints[cureentIndex]);

        setIsLoading(false);
      }
    } catch (error) {
      // console.log("138", error);
      // setCurrentIndex(cureentIndex+1);
      // console.error(`Error fetching ${apiEndPoints[i].type}:`, error);
      // setServerError(true);
      // break; // Stop further API calls if there's an error
    }
    // // setCurrentIndex(cureentIndex+1);
    // console.log("results",getResults);
    // console.log('151isLoading',isLoading);
    // console.log('reportgenerateData',reportgenerateData);
    setIsLoading(false);
  };

  const handleEditorChange = (section, val) => {
    // e.preventDefault();
    // console.log(section,val);
    setReportDisplayStatus((prevResults) => ({
      ...prevResults,
      [section]: !val,
    }));
  };
  const handleChange = (fieldName, value) => {
    // Update state or perform any other actions based on fieldName and value
    console.log(fieldName, value); // 'background_info', the value from ReactQuill
    setReportgenerateData((prevResults) => ({
      ...prevResults,
      // [fieldName]: turndownService.turndown(editorData),
      [fieldName]: value,
    }));
  };

  const handleApprove = async () => {
    const result = await MySwal.fire({
      title:
        "Are you sure you want to approve the report? Please download the report, as it will be deleted after 30 days.",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
    });
    if (result.isConfirmed) {
      // PATIENT_PAITENT_REPORT_API_URL
      try {
        // let obj = {
        //   background_info: turndownService.turndown(reportgenerateData.background_info),
        //   collateral: turndownService.turndown(reportgenerateData.collateral),
        //   mse: turndownService.turndown(reportgenerateData.mse),
        //   standardised_assessment: turndownService.turndown(reportgenerateData.standardised_assessment),
        //   clinical_interviews: turndownService.turndown(reportgenerateData.clinical_interviews),

        //   formulation: turndownService.turndown(reportgenerateData.formulation),
        //   diagnose: turndownService.turndown(reportgenerateData.diagnose),
        //   is_approved: true,
        // }
        setIsApprovedLoading(true);
        let obj = {
          background_info: reportgenerateData.background_info,
          collateral: reportgenerateData.collateral,
          mse: reportgenerateData.mse,
          standardised_assessment: reportgenerateData.standardised_assessment,
          clinical_interviews: reportgenerateData.clinical_interviews,
          history: reportgenerateData.history,

          formulation: reportgenerateData.formulation,
          diagnose: reportgenerateData.diagnose,
          is_approved: true,
        };
        // console.log("obj", obj);

        const response = await CallWithAuth(
          "PATCH",
          `${PATIENT_PAITENT_REPORT_API_URL}${id}`,
          obj
        );
        if (response?.res?.data?.statusCode === 200) {
          showToast("success", "Report has been saved successfully.");
          setReportGenerated(true);
        } else {
          showToast("error", response.res.data.message);
        }
        setIsApprovedLoading(false);
      } catch (error) {
        setIsApprovedLoading(false);
        console.log("error", error);
      }
    }

    // console.log("reportgenerateData====>", reportgenerateData);
  };
  // console.log("213", reportDisplayStatus);
  // console.log("213", reportgenerateData);
  const handleDownloadPdf = async () => {
    setIsReportDownload(true);
    const formattedHtml = Object.entries(reportgenerateData)
      .filter(([key]) => !key.endsWith("_generated")) // Remove "_generated" keys
      .map(([key, value]) => {
        // Format key: Replace "_" with space and capitalize words
        const formattedKey = key
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        return `<h3>${formattedKey}</h3> ${value}`; // Add as HTML
      })
      .join(" "); // Join all HTML
    let base64Logo = await convertImageToBase64(logo);

    const convertedContent = htmlToPdfMake(formattedHtml);
    const docDefinition = {
      pageSize: "A4", // Default is A4
      pageOrientation: "prtrait", // Set landscape mode
      content: [
        {
          image: base64Logo, // Insert the Base64 logo
          width: 100, // Adjust size
          alignment: "center", // Center align the logo
          margin: [0, 0, 0, 20], // Space below the logo
        },
        convertedContent, // Insert the formatted content
      ],
    };
    const fullName = reportData?.full_name
      ? reportData.full_name.replace(/\s+/g, "_")
      : "";

    const filename = reportData?.full_name
      ? `${fullName}_document_${reportDateDwonaloadDateFormat()}.pdf`
      : `document_${reportDateDwonaloadDateFormat()}.pdf`;

    // Now use pdfmake to generate PDF
    pdfMake.createPdf(docDefinition).download(filename);
    setIsReportDownload(false);

    // 🔹 Create a new DOM element with the concatenated HTM  L
  };
  console.log("reportGenerated", reportGenerated);

  return (
    <div>
      <section class="site_hero patient_management_banner">
        <div class="site_container">
          <div class="site_row">
            <div class="txt_colm"></div>
            <div class="img_colm">
              <div class="img_block">
                <img src={patient} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="foralign max-60 mb-5">
        <div class="site_container text-center" style={{ padding: "20px" }}>
          <h3>CONFIDENTIAL PSYCHOLOGIST REPORT</h3>
          <h5>
            <strong>Name:</strong> {reportData?.full_name}
          </h5>
          <h5>
            <strong>Phone:</strong> {reportData?.phone}
          </h5>
          <h5>
            <strong>D.O.B:</strong>{" "}
            {moment(reportData?.dob).format("DD/MM/yyyy")}
          </h5>
          <h5>
            <strong>Date of Assessment:</strong>{" "}
            {moment(reportData?.created_at).format("DD/MM/yyyy")}
          </h5>
          {/* <h3>Assessor: {}</h3> */}
          {/* <h3>Date of Assessment: {}</h3> */}
        </div>
      </div>

      {reportGenerated && (
        <>
          <div>
            <button
              onClick={handleDownloadPdf}
              className="approve-report-button"
              disabled={isReportDownload}
            >
              Download Report{" "}
              {isReportDownload && (
                <>
                  {""}
                  <LoaderIndex />
                </>
              )}
            </button>
          </div>
        </>
      )}
      {reportData?.metadata && (
        <>
          <div style={{ textAlign: "center" }}>
            <h2>Metadata</h2>
          </div>
          <MetadataSection
            setReportData={setReportData}
            metadata={reportData.metadata}
          />
        </>
      )}

      {/* background info */}
      {reportgenerateData.mse_generated && <></>}
      {/* {JSON.stringify(reportDisplayStatus)} */}
      {/* {reportDisplayStatus?.background_info} */}
      <div className="report-container-main">
        <h1>
          background info{" "}
          {!reportgenerateData?.background_info_generated && (
            <>
              {""}
              <LoaderIndex />
            </>
          )}
        </h1>
        <div
          className="report-container-child-cls"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          {!reportDisplayStatus?.background_info && (
            <>
              <div
                style={{
                  fontSize: "20px",
                  padding: "24px",
               background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                }}
                className="form-group report-container-new"
                dangerouslySetInnerHTML={{
                  __html: marked(reportgenerateData.background_info ?? ""),
                }}
              />
              {!reportGenerated && (
                <>
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "background_info",
                        reportDisplayStatus.background_info
                      )
                    }
                    disabled={!reportgenerateData?.background_info_generated}
                  >
                    Edit
                  </button>
                </>
              )}
            </>
          )}

          {reportDisplayStatus?.background_info && (
            <>
              {/* <ReactQuill
                value={marked(reportgenerateData.background_info ?? "")}
                theme="snow" // You can use 'snow', 'bubble', or other themes
                onChange={(value) => handleChange("background_info", value)} // Add param to handleChange
              /> */}
              {/* {marked(reportgenerateData.background_info ?? "")} */}

              <Editor
                apiKey={tinymceApiKey}
                onInit={(evt, editor) => {
                  editorRef.current = editor;
                  editor.setContent(editorContent); // Set initial content
                }}
                init={tinymceConfig}
                value={editorContent} // Use local state to prevent cursor jump
                onEditorChange={(value) => {
                  setEditorContent(value);
                }}
                onBlur={() => {
                  setReportgenerateData((prevData) => ({
                    ...prevData,
                    background_info: editorContent,
                  }));
                  handleChange("background_info", editorContent);
                }}
              />
              <button
                onClick={(e) =>
                  handleEditorChange(
                    "background_info",
                    reportgenerateData.background_info
                  )
                }
                className="view-report-button"
              >
                View
              </button>
            </>
          )}
        </div>
      </div>
      {/*End background info */}

      {/* Histroy */}

      <div className="report-container-main">
        <h1>
          history{" "}
          {!reportgenerateData?.history_generated && (
            <>
              {""}
              <LoaderIndex />
            </>
          )}
        </h1>
        <div
          className="report-container-child-cls"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          {!reportDisplayStatus?.history && (
            <>
              <div
                style={{
                  fontSize: "20px",
                  padding: "24px",
               background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                }}
                className="form-group report-container-new"
                dangerouslySetInnerHTML={{
                  __html: marked(reportgenerateData.history ?? ""),
                }}
              />
              {!reportGenerated && (
                <>
                  <button
                    onClick={(e) =>
                      handleEditorChange("history", reportDisplayStatus.history)
                    }
                    disabled={!reportgenerateData?.history_generated}
                  >
                    Edit
                  </button>
                </>
              )}
            </>
          )}

          {reportDisplayStatus?.history && (
            <>
              {/* <ReactQuill
                value={marked(reportgenerateData.history ?? "")}
                theme="snow" // You can use 'snow', 'bubble', or other themes
                onChange={(value) => handleChange("history", value)} // Add param to handleChange
              /> */}
              <Editor
                apiKey={tinymceApiKey}
                onInit={(evt, editor) => {
                  editorRef.current = editor;
                  editor.setContent(editorHistoryContent); // Set initial content
                }}
                init={tinymceConfig}
                value={editorHistoryContent} // Use local state to prevent cursor jump
                onEditorChange={(value) => {
                  setEditorHistoryContent(value);
                }}
                onBlur={() => {
                  setReportgenerateData((prevData) => ({
                    ...prevData,
                    history: editorHistoryContent,
                  }));
                  handleChange("history", editorHistoryContent);
                }}
              />
              <button
                onClick={(e) =>
                  handleEditorChange("history", reportgenerateData.history)
                }
                className="view-report-button"
              >
                View
              </button>
            </>
          )}
        </div>
      </div>
      {/* End histroy */}

      {/* collateral info */}
      <div className="report-container-main">
        <h1>
          collateral{" "}
          {!reportgenerateData?.collateral_generated && (
            <>
              {""}
              <LoaderIndex />
            </>
          )}
        </h1>
        <div
          className="report-container-child-cls"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          {!reportDisplayStatus?.collateral && (
            <>
              <div
                style={{
                  fontSize: "20px",
                  padding: "24px",
               background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                }}
                className="form-group report-container-new"
                dangerouslySetInnerHTML={{
                  // __html: marked(reportgenerateData.collateral??""),
                  __html: safeMarkedWrapper(
                    reportgenerateData.collateral ?? ""
                  ),
                }}
              />
              {!reportGenerated && (
                <>
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "collateral",
                        reportDisplayStatus.collateral
                      )
                    }
                    // disabled={!reportgenerateData?.collateral_generated}
                  >
                    Edit
                  </button>
                </>
              )}
            </>
          )}

          {reportDisplayStatus?.collateral && (
            <>
              {/* <ReactQuill
                // value={marked(reportgenerateData.collateral??"")}
                value={safeMarkedWrapper(reportgenerateData.collateral ?? "")}
                theme="snow" // You can use 'snow', 'bubble', or other themes
                onChange={(value) => handleChange("collateral", value)} // Add param to handleChange
              /> */}
              <Editor
                apiKey={tinymceApiKey}
                onInit={(evt, editor) => {
                  editorRef.current = editor;
                  editor.setContent(editorCollateralContent); // Set initial content
                }}
                init={tinymceConfig}
                value={editorCollateralContent} // Use local state to prevent cursor jump
                onEditorChange={(value) => {
                  setEditorCollateralContent(value);
                }}
                onBlur={() => {
                  setReportgenerateData((prevData) => ({
                    ...prevData,
                    collateral: editorCollateralContent,
                  }));
                  handleChange("collateral", editorCollateralContent);
                }}
              />
              <button
                onClick={(e) =>
                  handleEditorChange(
                    "collateral",
                    reportgenerateData.collateral
                  )
                }
                className="view-report-button"
              >
                View
              </button>
            </>
          )}
        </div>
      </div>

      {/* Edit collateral info */}

      {/* Mental Status Examination info */}

      {/* {reportgenerateData.mse_generated && ( */}
      <>
        <div className="report-container-main">
          <h1>
            Mental Status Examination{" "}
            {!reportgenerateData?.mse_generated && (
              <>
                {""}
                <LoaderIndex />
              </>
            )}{" "}
          </h1>
          <div
            className="report-container-child-cls"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            {!reportDisplayStatus?.mse && (
              <>
                <div
                  style={{
                    fontSize: "20px",
                    padding: "24px",
                 background: "#F9FAFC",
                    borderRadius: "10px",
                    width: "100%",
                  }}
                  className="form-group report-container-new"
                  dangerouslySetInnerHTML={{
                    __html: marked(reportgenerateData.mse),
                  }}
                />
                {!reportGenerated && (
                  <>
                    <button
                      onClick={(e) =>
                        handleEditorChange("mse", reportDisplayStatus.mse)
                      }
                      disabled={!reportgenerateData?.mse_generated}
                    >
                      Edit
                    </button>
                  </>
                )}
              </>
            )}

            {reportDisplayStatus?.mse && (
              <>
                {/* <ReactQuill
                  value={marked(reportgenerateData.mse)}
                  theme="snow" // You can use 'snow', 'bubble', or other themes
                  onChange={(value) => handleChange("mse", value)} // Add param to handleChange
                /> */}
                <Editor
                  apiKey={tinymceApiKey}
                  onInit={(evt, editor) => {
                    editorRef.current = editor;
                    editor.setContent(editorMseContent); // Set initial content
                  }}
                  init={tinymceConfig}
                  value={editorMseContent} // Use local state to prevent cursor jump
                  onEditorChange={(value) => {
                    setEditorMseContent(value);
                  }}
                  onBlur={() => {
                    setReportgenerateData((prevData) => ({
                      ...prevData,
                      mse: editorMseContent,
                    }));
                    handleChange("mse", editorMseContent);
                  }}
                />
                <button
                  onClick={(e) =>
                    handleEditorChange("mse", reportgenerateData.mse)
                  }
                  className="view-report-button"
                >
                  View
                </button>
              </>
            )}
          </div>
        </div>
      </>
      {/* )} */}

      {/* End Mental Status Examination info */}

      {/* standardised assessment info */}
      {/* {reportgenerateData.standardised_assessment_generated && ( */}
      <>
        <div className="report-container-main">
          <h1>
            standardised assessment{" "}
            {!reportgenerateData?.standardised_assessment_generated && (
              <>
                {""}
                <LoaderIndex />
              </>
            )}{" "}
          </h1>
          <div
            className="report-container-child-cls"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            {!reportDisplayStatus?.standardised_assessment && (
              <>
                <div
                  style={{
                    fontSize: "20px",
                    padding: "24px",
                 background: "#F9FAFC",
                    borderRadius: "10px",
                    width: "100%",
                  }}
                  className="form-group report-container-new"
                  dangerouslySetInnerHTML={{
                    __html: marked(reportgenerateData.standardised_assessment),
                  }}
                />
                {!reportGenerated && (
                  <>
                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "standardised_assessment",
                          reportDisplayStatus.standardised_assessment
                        )
                      }
                      disabled={
                        !reportgenerateData?.standardised_assessment_generated
                      }
                    >
                      Edit
                    </button>
                  </>
                )}
              </>
            )}

            {reportDisplayStatus?.standardised_assessment && (
              <>
                {/*<ReactQuill
                  value={marked(reportgenerateData.standardised_assessment)}
                  onChange={(value) =>
                    handleChange("standardised_assessment", value)
                  } // Add param to handleChange
                 
                />*/}
                <Editor
                  apiKey={tinymceApiKey}
                  onInit={(evt, editor) => {
                    editorRef.current = editor;
                    editor.setContent(editorMseContent); // Set initial content
                  }}
                  init={tinymceConfig}
                  value={editorStandardisedContent} // Use local state to prevent cursor jump
                  onEditorChange={(value) => {
                    setEditorStandardisedContent(value);
                  }}
                  onBlur={() => {
                    setReportgenerateData((prevData) => ({
                      ...prevData,
                      standardised_assessment: editorStandardisedContent,
                    }));
                    handleChange(
                      "standardised_assessment",
                      editorStandardisedContent
                    );
                  }}
                />

                <button
                  onClick={(e) =>
                    handleEditorChange(
                      "standardised_assessment",
                      reportgenerateData.standardised_assessment
                    )
                  }
                  className="view-report-button"
                >
                  View
                </button>
              </>
            )}
          </div>
        </div>
      </>
      {/* )} */}
      {/* end standardised assessment */}

      {/* clinical_interview info */}
      {/* {reportgenerateData?.clinical_interviews_generated && ( */}
      <>
        <div className="report-container-main">
          <h1>
            clinical interviews{" "}
            {!reportgenerateData?.clinical_interviews_generated && (
              <>
                {""}
                <LoaderIndex />
              </>
            )}{" "}
          </h1>
          <div
            className="report-container-child-cls"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            {!reportDisplayStatus?.clinical_interviews && (
              <>
                <div
                  style={{
                    fontSize: "20px",
                    padding: "24px",
                 background: "#F9FAFC",
                    borderRadius: "10px",
                    width: "100%",
                  }}
                  className="form-group report-container-new"
                  dangerouslySetInnerHTML={{
                    __html: marked(reportgenerateData.clinical_interviews),
                  }}
                />
                {!reportGenerated && (
                  <>
                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "clinical_interviews",
                          reportDisplayStatus.clinical_interviews
                        )
                      }
                      disabled={
                        !reportgenerateData?.clinical_interviews_generated
                      }
                    >
                      Edit
                    </button>
                  </>
                )}
              </>
            )}

            {reportDisplayStatus?.clinical_interviews && (
              <>
                <Editor
                  apiKey={tinymceApiKey}
                  onInit={(evt, editor) => {
                    editorRef.current = editor;
                    editor.setContent(editorClinicalInterviewsContent); // Set initial content
                  }}
                  init={tinymceConfig}
                  value={editorClinicalInterviewsContent} // Use local state to prevent cursor jump
                  onEditorChange={(value) => {
                    setEditorClinicalInterviewsContent(value);
                  }}
                  onBlur={() => {
                    setReportgenerateData((prevData) => ({
                      ...prevData,
                      clinical_interviews: editorClinicalInterviewsContent,
                    }));
                    handleChange(
                      "clinical_interviews",
                      editorClinicalInterviewsContent
                    );
                  }}
                />
                <button
                  onClick={(e) =>
                    handleEditorChange(
                      "clinical_interviews",
                      reportgenerateData.clinical_interviews
                    )
                  }
                  className="view-report-button"
                >
                  View
                </button>
              </>
            )}
          </div>
        </div>
      </>
      {/* )} */}
      {/* end clinical_interviews  */}

      {/* formulation */}

      {/* formulation start here */}
      <div className="report-container-main">
        <h1>
          formulation{" "}
          {!reportgenerateData?.formulation_generated && (
            <>
              {""}
              <LoaderIndex />
            </>
          )}{" "}
        </h1>
        <div
          className="report-container-child-cls"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          {!reportDisplayStatus?.formulation && (
            <>
              <div
                style={{
                  fontSize: "20px",
                  padding: "24px",
               background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                }}
                className="form-group report-container-new"
                dangerouslySetInnerHTML={{
                  __html: marked(reportgenerateData.formulation),
                }}
              />
              {!reportGenerated && (
                <>
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "formulation",
                        reportDisplayStatus.formulation
                      )
                    }
                    disabled={!reportgenerateData?.formulation_generated}
                  >
                    Edit
                  </button>
                </>
              )}
            </>
          )}

          {reportDisplayStatus?.formulation && (
            <>
              {/* <ReactQuill
                value={marked(reportgenerateData.formulation)}
                onChange={(value) => handleChange("formulation", value)} // Add param to handleChange
                // formats={[
                //   "bold",
                //   "italic",
                //   "underline",
                //   "strike",
                //   "blockquote",
                //   "list",
                //   "bullet",
                //   "indent",
                //   "link",
                //   "image",
                //   "header",
                //   "font",
                //   "align",
                //   "size",
                //   "color",
                //   "background",
                //   "code-block",
                //   "table",
                // ]}
                // modules={{
                //   toolbar: [
                //     [{ header: "1" }, { header: "2" }, { font: [] }],
                //     [{ list: "ordered" }, { list: "bullet" }],
                //     ["bold", "italic", "underline"],
                //     [{ align: [] }],
                //     ["blockquote", "code-block"],
                //   ],
                // }}
              /> */}
              <Editor
                apiKey={tinymceApiKey}
                onInit={(evt, editor) => {
                  editorRef.current = editor;
                  editor.setContent(editorFormulationContent); // Set initial content
                }}
                init={tinymceConfig}
                value={editorFormulationContent} // Use local state to prevent cursor jump
                onEditorChange={(value) => {
                  setEditorFormulationContent(value);
                }}
                onBlur={() => {
                  setReportgenerateData((prevData) => ({
                    ...prevData,
                    formulation: editorFormulationContent,
                  }));
                  handleChange("formulation", editorFormulationContent);
                }}
              />
              <button
                onClick={(e) =>
                  handleEditorChange(
                    "formulation",
                    reportgenerateData.formulation
                  )
                }
                className="view-report-button"
              >
                View
              </button>
            </>
          )}
        </div>
      </div>
      {/* end formulation */}

      {/* diagnose start here */}
      <div className="report-container-main">
        <h1>
          diagnose{" "}
          {!reportgenerateData?.diagnose_generated && (
            <>
              {""}
              <LoaderIndex />
            </>
          )}{" "}
        </h1>
        <div
          className="report-container-child-cls"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          {!reportDisplayStatus?.diagnose && (
            <>
              <div
                style={{
                  fontSize: "20px",
                  padding: "24px",
               background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                }}
                className="form-group report-container-new"
                dangerouslySetInnerHTML={{
                  __html: marked(reportgenerateData.diagnose),
                }}
              />
              {!reportGenerated && (
                <>
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "diagnose",
                        reportDisplayStatus.diagnose
                      )
                    }
                    disabled={!reportgenerateData?.diagnose_generated}
                  >
                    Edit
                  </button>
                </>
              )}
            </>
          )}

          {reportDisplayStatus?.diagnose && (
            <>
              {/* <ReactQuill
                value={marked(reportgenerateData.diagnose)}
                onChange={(value) => handleChange("diagnose", value)} // Add param to handleChange
                // formats={[
                //   "bold",
                //   "italic",
                //   "underline",
                //   "strike",
                //   "blockquote",
                //   "list",
                //   "bullet",
                //   "indent",
                //   "link",
                //   "image",
                //   "header",
                //   "font",
                //   "align",
                //   "size",
                //   "color",
                //   "background",
                //   "code-block",
                //   "table",
                // ]}
                // modules={{
                //   toolbar: [
                //     [{ header: "1" }, { header: "2" }, { font: [] }],
                //     [{ list: "ordered" }, { list: "bullet" }],
                //     ["bold", "italic", "underline"],
                //     [{ align: [] }],
                //     ["blockquote", "code-block"],
                //   ],
                // }}
              /> */}
              <Editor
                apiKey={tinymceApiKey}
                onInit={(evt, editor) => {
                  editorRef.current = editor;
                  editor.setContent(editorDiagnoseContent); // Set initial content
                }}
                init={tinymceConfig}
                value={editorDiagnoseContent} // Use local state to prevent cursor jump
                onEditorChange={(value) => {
                  setEditorDiagnoseContent(value);
                }}
                onBlur={() => {
                  setReportgenerateData((prevData) => ({
                    ...prevData,
                    diagnose: editorDiagnoseContent,
                  }));
                  handleChange("diagnose", editorDiagnoseContent);
                }}
              />
              <button
                onClick={(e) =>
                  handleEditorChange("diagnose", reportgenerateData.diagnose)
                }
                className="view-report-button"
              >
                View
              </button>
            </>
          )}
        </div>
      </div>
      {/* end diagnose */}

      {/* recommendation start here */}
      <div className="report-container-main">
        <h1>
          recommendation{" "}
          {!reportgenerateData?.recommendation_generated && (
            <>
              {""}
              <LoaderIndex />
            </>
          )}{" "}
        </h1>
        <div
          className="report-container-child-cls"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          {!reportDisplayStatus?.recommendation && (
            <>
              <div
                style={{
                  fontSize: "20px",
                  padding: "24px",
               background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                }}
                className="form-group report-container-new"
                dangerouslySetInnerHTML={{
                  __html: marked(reportgenerateData.recommendation),
                }}
              />
              {!reportGenerated && (
                <>
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "recommendation",
                        reportDisplayStatus.recommendation
                      )
                    }
                    disabled={!reportgenerateData?.recommendation_generated}
                  >
                    Edit
                  </button>
                </>
              )}
            </>
          )}

          {reportDisplayStatus?.recommendation && (
            <>
              {/* <ReactQuill
                value={marked(reportgenerateData.recommendation)}
                onChange={(value) => handleChange("recommendation", value)} // Add param to handleChange
                // formats={[
                //   "bold",
                //   "italic",
                //   "underline",
                //   "strike",
                //   "blockquote",
                //   "list",
                //   "bullet",
                //   "indent",
                //   "link",
                //   "image",
                //   "header",
                //   "font",
                //   "align",
                //   "size",
                //   "color",
                //   "background",
                //   "code-block",
                //   "table",
                // ]}
                // modules={{
                //   toolbar: [
                //     [{ header: "1" }, { header: "2" }, { font: [] }],
                //     [{ list: "ordered" }, { list: "bullet" }],
                //     ["bold", "italic", "underline"],
                //     [{ align: [] }],
                //     ["blockquote", "code-block"],
                //   ],
                // }}
              /> */}

              <Editor
                apiKey={tinymceApiKey}
                onInit={(evt, editor) => {
                  editorRef.current = editor;
                  editor.setContent(editorRecommendationContent); // Set initial content
                }}
                init={tinymceConfig}
                value={editorRecommendationContent} // Use local state to prevent cursor jump
                onEditorChange={(value) => {
                  setEditorRecommendationContent(value);
                }}
                onBlur={() => {
                  setReportgenerateData((prevData) => ({
                    ...prevData,
                    recommendation: editorRecommendationContent,
                  }));
                  handleChange("recommendation", editorRecommendationContent);
                }}
              />
              <button
                onClick={(e) =>
                  handleEditorChange(
                    "recommendation",
                    reportgenerateData.recommendation
                  )
                }
                className="view-report-button"
              >
                View
              </button>
            </>
          )}
        </div>
      </div>
      {/* end recommendation */}
      <>
        {isReportGenerate && !reportGenerated && (
          <div>
            <button
              onClick={handleApprove}
              disabled={isApprovedLoading}
              className="approve-report-button"
            >
              Approve{" "}
              {isApprovedLoading && (
                <>
                  {""}
                  <LoaderIndex />
                </>
              )}{" "}
            </button>
          </div>
        )}
      </>
      {/* <>{marked(reportgenerateData.background_info)}</> */}
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <div className="full-page-loader">
            <div className="loader"></div>
          </div>
        </>
      )}
      {/* <div className="report-container">
        {Object.entries(reportgenerateData).map(([key, value]) => (
          <>
            {value && (
              <>
                <div key={key} className="report-section">
                  <h3>{key=='mse' ? (<>Mental Status Examination</>) : (<>{key.replace(/_/g, " ").toUpperCase()}</>)}</h3>
                  {value && value != "" ? (
                    // <p
                    //   dangerouslySetInnerHTML={{
                    //     __html: value.replace(/\n/g, "<br />"),
                    //   }}
                    // />
                    <p
                      dangerouslySetInnerHTML={{
                        __html: value.replace(/\n/g, "<br />"),
                      }}
                    />
                  ) : (
                    <p>No data available.</p>
                  )}
                </div>
              </>
            )}
          </>
        ))}
      </div> */}

      <div className="foralign max-60 mb-5">
        <div class="site_container">
          {/* <h3>Recommendations </h3> */}
          <br />
          <br />
          <div>
            {/* <span>
              The following is recommended for{" "}
              <strong>{reportData?.full_name}</strong>:{" "}
            </span> */}
          </div>
          <br />
          <br />
          <div>
            <span>
              If you should have any questions or concerns about the content of
              this report, please get in contact with written parental consent
              from <strong>{reportData?.full_name}</strong>.{" "}
            </span>
          </div>
          <br />
          <div>
            <span>cc: [auto populate patient’s treating doctor]</span>
          </div>
          <br />
          <div>
            <span>Warm Regards</span>
          </div>
          <br />
          <div>
            <span></span>
          </div>
          <div>
            <span>
              {/* <strong>{`${reportData?.user?.first_name} ${reportData?.user?.last_name}`}</strong> */}
            </span>
          </div>
          <div>
            <span>Clinical Psychology Registrar/Psychologist (MAPS)</span>
          </div>
          <div>
            <span>
              <strong>{`${reportData?.user?.email}`}</strong>{" "}
            </span>
          </div>
          <div>
            <span>AHPRA No: PSY0002178238 </span>
          </div>
        </div>
      </div>

      {/* {reportData?.assessment && (
        <>
          <div style={{ textAlign: "center" }}>
            <h2>Assessment</h2>
          </div>
          <AssessmentSection
            setReportData={setReportData}
            metadata={reportData.assessment}
          />
        </>
      )}
      {reportData?.recommendation && (
        <>
          <div style={{ textAlign: "center" }}>
            <h2>Recommendation</h2>
          </div>
          <RecommendationSection
            setReportData={setReportData}
            initialRecommendation={reportData.recommendation}
          />
        </>
      )} */}

      {/* <div class="btn_row">
        <Link to={"#"} class="solid_cta cta_primary cta_with_icon">
          <span>Save</span> <img src={arrorRight} alt="" />
        </Link>
      </div> */}
      <ToastContainer />
    </div>
  );
};

export default PatientReportInformationPage;
